import KngPoints from '../kng-operator/src/components/widget/form-point.vue';
KngPoints.name = 'YxtbizKngPoints';
/* istanbul ignore next */
KngPoints.install = function(Vue) {
  Vue.component(KngPoints.name, KngPoints);
};

export default KngPoints;
